import { createFileRoute } from "@tanstack/react-router"

import { DocumentDetailView } from "@/features/billing/components/document-detail-view"
import { invoiceQueryOptions } from "@/features/billing/hooks/use-billing"
import { warm } from "@/lib/router/warm"

export const Route = createFileRoute("/_shell/billing/documents/$id")({
  // Awaited (bounded): the page paints with its data, not skeletons.
  loader: ({ context: { queryClient }, params }) =>
    warm(queryClient, [
      invoiceQueryOptions(params.id),
    ]),
  component: DocumentDetailRoute,
})

function DocumentDetailRoute() {
  const { id } = Route.useParams()
  // Keyed so moving between related documents resets the page's dialogs.
  return <DocumentDetailView key={id} id={id} />
}
